import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {Config} from '../../Config'
import moment from "moment-timezone";
import * as Utils from "../../inc/Utils";

export default function Shortio() {
    let id = 1;

    const roles = new Role();
    let userId = roles.loginUserId;

    let btnTextDefault = 'อัพเดตข้อมูล';
    let btnTextLoading = 'กำลังอัพเดต..';
    let [isLoading, setLoading] = React.useState(false);
    let [data, setData] = React.useState('');
    let [statusChecked, setStatusChecked] = React.useState(false);
    let [shortioAccount, setShortioAccount] = React.useState(false);

    let refName = React.useRef();
    let refApikey = React.useRef(); 
    let refEndpoint = React.useRef();
    let refDomain = React.useRef();
    let refDomainId = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                await firstLoad();
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function firstLoad() {
        const resView = await getView();
        setData(resView);
        setStatusChecked(resView.status===1);

        const resAcc = await getShortioAccount(resView.domainId);
        setShortioAccount(resAcc);
    }

    async function getView() {
        const response = await fetch(Config.url.API_URL +'/api/shortio/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getShortioAccount(domainId) {
        const body = {
            domainId: domainId
        };
        const response = await fetch(Config.url.API_URL +'/api/shortio/getDomainDetail', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type':'application/json',
                'x-access-token': roles.accessToken
            }
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    const onUpdate = () => {
        let name = refName.current.value;
        let apikey = refApikey.current.value; 
        let endpoint = refEndpoint.current.value;
        let domain = refDomain.current.value;
        let domainId = refDomainId.current.value;
        if(!name) {
            toast.error("กรุณาระบุ ชื่อ");
            refName.current.focus();
        }
        else if(!apikey) {
            toast.error("กรุณาระบุ API KEY");
            refApikey.current.focus();
        }
        else if(!endpoint) {
            toast.error("กรุณาระบุ Endpoint");
            refEndpoint.current.focus();
        }
        else if(!domain) {
            toast.error("กรุณาระบุ Domain");
            refDomain.current.focus();
        }
        else if(!domainId) {
            toast.error("กรุณาระบุ Domain Id");
            refDomainId.current.focus();
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการอัพเดตข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                id: data.id,
                                name: name,
                                domain: domain,
                                domainId: domainId,
                                apikey: apikey,
                                endpoint: endpoint,
                                status: statusChecked[0].checked ? 1:0,
                                updatedBy: userId,
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                            };
                            fetch(Config.url.API_URL +'/api/shortio/update', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(async response => {
                                setLoading(false);
                                await firstLoad();
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("อัพเดตข้อมูลเรียบร้อย");
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    if(data) {
        refName.current.value = data.name;
        refApikey.current.value = data.apiKey;
        refEndpoint.current.value = data.endpoint;
        refDomain.current.value = data.domain;
        refDomainId.current.value = data.domainId;
    }

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Shortio</div>
                    <span className="ms-1">/</span> <span className="text-muted">Edit</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form className="row g-3">
                            <div className="col-12">
                                <label htmlFor="name" className="form-label">ชื่อ <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="apikey" className="form-label">API KEY <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="apikey" ref={refApikey} maxLength={200} />
                                <p className="text-muted mb-0 mt-1 small">Secret key เท่านั้น ขึ้นต้นด้วย sk_xxxxyyyy</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="endpoint" className="form-label">Endpoint <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" id="endpoint" ref={refEndpoint} maxLength={200} />
                                <p className="text-muted mb-0 mt-1 small">ห้ามมี / หลังสุด</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="domain" className="form-label">Domain</label>
                                <input type="text" className="form-control" id="domain" ref={refDomain} maxLength={200} />
                                <p className="text-muted mb-0 mt-1 small">ห้ามมี / หลังสุด และไม่ต้องระบุ http(s)</p>
                            </div>
                            <div className="col-12">
                                <label htmlFor="domainId" className="form-label">Domain Id</label>
                                <input type="text" className="form-control" id="domainId" ref={refDomainId} maxLength={200} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="statusx" className="form-label">สถานะ</label>
                                <div className="form-check form-switch">
                                    <input className="form-check-input" type="checkbox" name="statusChecked" id="status" checked={statusChecked} onChange={e => {setStatusChecked(e.target.checked)}} disabled={!roles.isEdit(Utils.MENU_SHORTIO)} />
                                    <label className="form-check-label" htmlFor="status"></label>
                                </div>
                            </div>
                            {
                                roles.isEdit(Utils.MENU_SHORTIO) ?
                                    <div className="col-12">
                                        <button type="button" className="btn btn-primary" onClick={onUpdate}><span
                                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                        <Toaster position="bottom-right" />
                                    </div> : ''
                            }
                        </form>
                    </div>
                    <div className="col-12 col-md-6">
                        <div className="bg-yellow-light rounded p-2">
                            <label htmlFor="name" className="form-label">Domain Statistics</label>
                            <ul className="list-group">
                                <li className="list-group-item">clicks : {shortioAccount.clicks}</li>
                                <li className="list-group-item">humanClicks : {shortioAccount.humanClicks}</li>
                                <li className="list-group-item">links : {shortioAccount.links}</li>
                                <li className="list-group-item">clicksPerLink : {shortioAccount.clicksPerLink}</li>
                                <li className="list-group-item">humanClicksPerLink : {shortioAccount.humanClicksPerLink}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
} 